import * as React from 'react';
import { OtaTaskProps } from '@ixicare/resources';
import { CircleAlert, CircleCheck, Clock, Cog, Download, Hourglass, Send } from 'lucide-react';
import { t } from '~i18n';
import { otaTaskState, otaTaskStateLabel, OtaTaskState } from '../utils/otaTaskState';
import styles from './SoftwareVersionCell.module.css';

const ICONS: Record<OtaTaskState, typeof Clock> = {
  scheduled: Clock,
  waitingForDevice: Clock,
  delivered: Send,
  waitingForDownload: Clock,
  downloading: Download,
  waitingForInstall: Hourglass,
  installing: Cog,
  done: CircleCheck,
  failed: CircleAlert,
};

interface Props {
  version?: string;
  task?: OtaTaskProps;
  onOpen: () => void;
}

/** The software version, opening the device's firmware details, with a pending update next to it. */
export const SoftwareVersionCell = ({ version, task, onOpen }: Props) => {
  const state = task && otaTaskState(task);
  const Icon = state && ICONS[state];
  const label = task ? otaTaskStateLabel(task) : t('firmware.device.open');

  return (
    <button
      type="button"
      className={styles.Cell}
      title={label}
      aria-label={label}
      onClick={(event) => {
        event.stopPropagation();
        onOpen();
      }}
    >
      <span className={styles.Version}>{version ?? '—'}</span>
      {task && Icon && (
        <span className={styles.Badge} data-state={state}>
          <Icon size={13} strokeWidth={2.2} aria-hidden="true" />
          {task.firmware?.version && <span>{task.firmware.version}</span>}
        </span>
      )}
    </button>
  );
};
